import {} from 'vue';
import {} from '@ts/components/form/types';
export function isFileList(value) {
    return value instanceof FileList;
}
export function isDbFileList(value) {
    return value !== null && ((value instanceof FileList) === false);
}
export function isFile(value) {
    return value instanceof File;
}
export function isDbFile(value) {
    return (value instanceof File) === false;
}
export function setError(errors, errorId, errorKey, errorMessage) {
    // const currErrors = {...(errors.value[errorId] || {})};
    // const newErrors = {
    //   ...currErrors,
    //   [errorKey]: errorMessage,
    // };
    // errors.value = {...errors.value, [errorId]: newErrors};
    if (errors.value[errorId] === undefined) {
        errors.value[errorId] = {};
    }
    errors.value[errorId][errorKey] = errorMessage;
}
export function removeError(errors, errorId, errorKey) {
    if (errors.value && errors.value[errorId] && errors.value[errorId][errorKey]) {
        delete errors.value[errorId][errorKey];
        // const newErrors = {...(errors.value[errorId] || {})};
        // delete newErrors[errorKey];
        // if (Object.keys(newErrors).length === 0) {
        //   const {[errorId]: _, ...rest} = errors.value;
        //   errors.value = rest;
        // } else {
        //   errors.value = {...errors.value, [errorId]: newErrors};
        // }
    }
}
export function removeAllErrors(errors, errorId) {
    if (errors.value && errors.value[errorId]) {
        const { [errorId]: _, ...rest } = errors.value;
        errors.value = rest;
    }
}
export function mergeErrors(errors) {
    const mergedErrors = {};
    for (const errorId in errors) {
        const errorObj = errors[errorId];
        for (const key in errorObj) {
            mergedErrors[`${errorId}-${key}`] = errorObj[key];
        }
    }
    return mergedErrors;
}
export function hasErrors(errors, errorId) {
    if (errorId !== undefined) {
        return (errors[errorId] && Object.keys(errors[errorId]).length > 0) ? true : false;
    }
    return Object.values(errors).some(errorObj => Object.keys(errorObj).length > 0);
}
